module.exports = __webpack_public_path__ + "img/sbhq.14c5d4c6.jpg";